<!--
custom sort-link that doesnt change size when unsorted and uses text not link color
https://github.com/BernhardtD/vue-sorted-table
-->


<style scoped lang="scss">
  @import '@/assets/styles/variables.scss';
  .invis {
    color: transparent;
  }

  table tr th a {
      color: $text;
  }
</style>

<template>
  <a href="#" @click.prevent="sortBy(name)">
    <slot>{{ name }}</slot>
    <slot name="icon">
      <span v-if="getCurrentSort() == name" v-html="getSortIcon()" />
      <span class="invis" v-else v-html="getSortIcon()" />
    </slot>
  </a>
</template>


<script>
import { SortLink } from "vue-sorted-table";

export default {
  name: 'sort-link',
  mixins: [SortLink],
};
</script>
